const AREA_RESTRITA = '/area-restrita/';

export default {
  videos: AREA_RESTRITA+'videos/',
  planos_alimentares: AREA_RESTRITA+'planos-alimentares/',
  exercicios: AREA_RESTRITA+'exercicios/',
  blocos: AREA_RESTRITA+'blocos/',
  blocosPlanilha: AREA_RESTRITA+'blocos-planilha/',
  planilhasTreino: AREA_RESTRITA+'planilhas-treino/',
  exerciciosDomiciliares: AREA_RESTRITA+'treino-domiciliar/',
  usuarios: AREA_RESTRITA+'usuarios/', 
};



// WEBPACK FOOTER //
// ./src/config/Pages.js